export default __webpack_public_path__ + "static/media/stacked-cards@2x.7c78686c.png";